import { Component , OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-404',
  templateUrl: './404.component.html',
})
export class ErrorComponent implements OnInit {
  ngOnInit() {
  }
}
